import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../controls/Icons/Icon";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import { CommingSoon, dateDisplayFormater } from "../../../Utils";
import InvoicePayOutUpdate from "./InvoicePayOutUpdate";
import { PaymentUpdateAction } from "../../../Reducer/PaymentUpdateReducer";
import InvoicePayInUpdate from "./InvoicePayInUpdate";
import { InvoiceApprovalAction } from "../../../Reducer/InvoiceApprovalReducer";
import InvoiceNotes from "./InvoiceNotes";
import { InvoiceNotesAction } from "../../../Reducer/InvoiceNotesReducer";
import InvoiceEditApproval from "./InvoiceEditApproval";
import { InvoiceEditApprovalAction } from "../../../Reducer/InvoiceEditApprovalReducer";
import InvoiceSummaryNotes from "./InvoiceSummaryNotes";
import invoiceForApproval from "./InvoiceForApproval";


export default function InvoiceforApproval() {
    const state = useSelector(state => state);
    const [invoiceDateflg, setinvoiceDateflg] = useState(false);
    const formRef = useRef();
    const [validated, setValidated] = useState(false);
    const [TotalPayoutAmt, setTotalPayoutAmt] = useState(0);
    const [TotalPayInAmt, setTotalPayInAmt] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);
    //const [showPayOutModal, setshowPayOutModal] = useState(false);
    const dispatch = useDispatch();
   // const [showPayInModal, setshowPayInModal] = useState(false);
    const [ShowNotes, setShowNotes] = useState(false);
    const [ShowInvEdit, setShowInvEdit] = useState(false);
    const [NotesInvId, setNotesInvId] = useState("");
    const [isExceedingAmt, setisExceedingAmt] = useState(false);
    const [data, setData] = useState({
        Id: 0,
        ClientId: 0,
        ClientName: "",
        InvoiceNumber: "",
        InvoiceDate: "",
        InvoiceAmount: 0,
        TotalInvoiceAmount: 0,
        ReceivedAmount: 0,
        PaidtoIFAmount: 0,
        StatusId: 0,
        Status: "",
        CoOridinatorName: "",
        InvoicetypeId: 0,
        InvoicetypeName: "",
        Notes: "",
        IFAvailableAmt: 0,
        IFSpentAmt: 0,
        InvoiceOwnerName:''

    });

    useEffect(() => {
        fetch(state.projectdetail.API + "/invoice/GetInvoiceGrid?pageNumber=1&pageSize=10", {
            method: "Get"
        }).then(response => response.json()).then((res) => {
            if (res) {
                setTotalAmount(res.TotalAmount);
                setTotalPayoutAmt(res.TotalPayoutAmt);
                setTotalPayInAmt(res.TotalPayInAmt);
                if (res.IFAvailableAmt > (res.IFSpentAmt + res.InvoiceAmount)) {
                    setisExceedingAmt(true);
                }
                setData(res.invoiceGrid);
                setinvoiceDateflg(!invoiceDateflg);
            }
            else {
                window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            }

        }).catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
            console.log(err)
        }).finally(() => {
            //setLoading(false);
        });
    }, []);
    useEffect(() => {
    }, [invoiceDateflg]);
    const handleChkBox = (e, rowData) => {
        if (e.target.checked == true) {
            dispatch({ type: InvoiceApprovalAction.AddInvoiceForApproval, payload: rowData });
        } else {
            dispatch({ type: InvoiceApprovalAction.RemoveInvoiceForApproval, payload: rowData.Id });
        }
     
    }
    const [selInvId, setselInvId] = useState();
    const [selInvNumber, setInvNumber] = useState();
    const [selInvstatusId, setselInvstatusId] = useState();
    const [Invoicedata, setInvoicedata] = useState({
        Id: 0,
        InvoiceNumber: "",
        StatusId: 0,
    })
    const handleNotes = (e, rowData) => {
        //console.log("rowData");
        //console.log(rowData);
        setInvoicedata(rowData);
        setInvNumber(rowData.InvoiceNumber);
        setselInvstatusId(rowData.invStatusId);
        dispatch({ type: InvoiceNotesAction.AddInvIDForNotes, payload: rowData.Id })

        //console.log(selInvId);
        //console.log("rowData.invoiceId :" + rowData.invoiceId);
        //console.log(selInvNumber);
        setShowNotes(!ShowNotes);
    }
    const CloseNotes = () => {
        setShowNotes(false);
    }
    const handleSaveNotes = () => {
       // console.log("hanbleSaveNotes");
    }
   
    const handleSelect = (rowData) => {
        console.log("from Action JP");
        console.log(rowData);
        setInvoicedata(rowData);
        //console.log(Invoicedata.selInvId);
        //console.log(Invoicedata.selInvNumber);
        setselInvId(rowData.invoiceId);
        setInvNumber(rowData.InvoiceNumber);
        setselInvstatusId(rowData.invStatusId);
        let exceedingIFAvailAmt = false;
        if (rowData.IFAvailableAmt > (rowData.IFSpentAmt + rowData.InvoiceAmount)) {
            setisExceedingAmt(true);
            exceedingIFAvailAmt = true;
        }
        dispatch({ type: InvoiceEditApprovalAction.AddInvIDForEditApproval, payload: { InvoiceNumber: rowData.InvoiceNumber, fkInvoiceId: rowData.Id, IFAvailableAmt: rowData.IFAvailableAmt, IFSpentAmt: rowData.IFSpentAmt, InvoiceAmt: rowData.InvoiceAmount, InvoicetypeId: rowData.InvoicetypeId } });
        setShowInvEdit(true);
       // console.log(rowData);
    }
    const CloseInvEdit = () => {
        setShowInvEdit(false);
    }
    const handleUpdtInvStatus = () => {
        setShowInvEdit(false);
        //navigate("/admin/invoice");
       // console.log("update status called");
    }
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>

                <Row>
                    {/*<Col>*/}
                    {/*    <Card className="border">*/}
                    {/*        <Card.Body>*/}
                    {/*        </Card.Body>*/}
                    {/*    </Card>*/}
                    {/*</Col>*/}
                </Row>
                <Row>
                    <Col>
                        <Card className="border">
                            <Card.Body>
                                <Row md={12}>
                                    <Col md={6}>
                                        <h5> Invoice for Approval:</h5>
                                    </Col>
                                </Row>
                                <Row> &nbsp;&nbsp;&nbsp;
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Table responsive className="table" style={{ border: '1' }}>
                                            <thead border='1'>

                                                {/*<th md={1} border='1'></th>*/}
                                                {/*<th md={1} border='1'>Sl.No</th>*/}
                                                <th md={2} border='1'>ClientName</th>
                                                <th md={1}>Invoice Number</th>
                                                {/*<th md={1} >Status</th>*/}
                                                <th md={1}>Invoice Date</th>
                                                <th md={1}>Invoice Type</th>
                                                <th md={1}>Invoice Value</th>
                                                <th md={1}>IF(Independant Facilitator)</th>
                                                <th md={1}>Age since Last update</th>
                                                <th md={1}>Invoice Age</th>
                                                <th md={1}>Notes</th>
                                                
                                            </thead>

                                            <tbody>
                                                {data && data.length > 0 && data.map((rowData, rindex, key) => {
                                                   
                                                    return (
                                                            <tr key={rowData.Id}>
                                                                {/*<td>*/}
                                                                {/*    <input type="checkbox" id={"chk_" + rowData.Id}*/}
                                                                {/*        className="btn-xs me-2 mb-2 p-0"*/}
                                                                {/*        onClick={(e) => {*/}
                                                                {/*            handleChkBox(e, rowData);*/}
                                                                {/*        }}*/}
                                                                {/*    />*/}
                                                                {/*</td>*/}
                                                                {/*<td>*/}
                                                                {/*    {rindex + 1}*/}
                                                                {/*</td>*/}
                                                                {rowData.ClientName}
                                                                {/*<td>*/}
                                                                {/*    {rowData.Status}*/}
                                                                {/*</td>*/}
                                                                <td>
                                                                     <Button
                                                                        className="btn-xs me-2 mb-2 p-0" variant="link"
                                                                        onClick={() => handleSelect(rowData)}
                                                                    >{rowData.InvoiceNumber}</Button> 

                                                                </td>
                                                                {/*<td>{rowData.Status.Description}</td>*/}
                                                                <td>
                                                                    {dateDisplayFormater(rowData.InvoiceDate)}
                                                                </td>
                                                                <td>
                                                                    {rowData.InvoicetypeName.Description}
                                                                </td>
                                                                <td>
                                                                    {rowData.InvoiceAmount}
                                                                </td>
                                                                <td>
                                                                {rowData.InvoiceOwnerName}
                                                                </td>
                                                                <td>
                                                                    {rowData.lastUpdateAge} day(s)
                                                                </td>
                                                                <td>
                                                                    {rowData.InvoiceAge} day(s)
                                                                </td>
                                                                <td>
                                                                    <Button text="Notes" variant="link" tooltip="Notes"
                                                                        className="btn-xs me-2 p-0"
                                                                        onClick={(e) => {
                                                                            handleNotes(e, rowData);
                                                                        }}
                                                                    > <Icon name="BsPencilSquare" title="Notes" className='fs-5' /></Button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                             
                                               )
                                                }
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <Modal size="lg" show={ShowNotes} onHide={CloseNotes} backdrop="static">
                                        <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                            <h4>Invoice Notes</h4>
                                            <CloseButton onClick={CloseNotes} className="btn-close" />
                                        </Modal.Header>
                                        <Modal.Body>
                                            {/*<InvoiceNotes afterSave={handleSaveNotes} _inputValue={NotesInvId} onCancel={CloseNotes} />*/}
                                            <InvoiceSummaryNotes invoiceId={Invoicedata.Id} onCancel={CloseNotes} StatusId={Invoicedata.StatusId} InvoiceNumber={Invoicedata.InvoiceNumber} saveAfter={CloseNotes} />
                                        </Modal.Body>
                                    </Modal>

                                    <Modal size="lg" show={ShowInvEdit} onHide={CloseInvEdit} backdrop="static">
                                        <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                            <h4>Invoice Actions</h4>
                                            <CloseButton onClick={CloseInvEdit} className="btn-close" />
                                        </Modal.Header>
                                        <Modal.Body>
                                            <InvoiceEditApproval afterSave={handleUpdtInvStatus} _inputValue={NotesInvId} onCancel={CloseNotes} />
                                        </Modal.Body>
                                    </Modal>

                                    
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Form>
    </ErrorBoundary>
    );
}

